module.exports = "<div class=q-marg-vert-lg> <div class=q-marg-horz-xl> <div class=\"row q-marg-bottom-md\"> <div class=col-xs-12> <span>By updating a team member's password, an email will be sent with a temporary password and instructions for the team member to log in and change their password.</span> </div> </div> <div class=row> <div class=col-xs-12> <span>Do you wish to continue?</span> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/teamMembers/details/sharedHtml/updatePasswordModal.html
// module id = 1436
// module chunks = 1